import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import fairLogo from '@/assets/images/aridhia-fair-logo.svg';
import { endpoints } from '@/constants/urls';

const HomeLogo = () => {
  const [image, setImage] = useState(`${endpoints.API_IMAGES}aridhia-fair-logo.svg`);
  const intl = useIntl();

  return (
    <img
      src={image}
      className="aridhia-home-logo ui image logo"
      alt={intl.formatMessage({ id: 'header.icon.alt' })}
      onError={() => setImage(fairLogo)}
    />
  );
};

export default HomeLogo;
